import React, { useState, useEffect, useRef } from "react";
import "./LoginModal.css";
import axiosConfig from "../../Service/AxiosConfig";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { HiArrowLongLeft } from "react-icons/hi2";
import { useAuth } from "../Utils/AuthContext";
import sandyLoading from "../Animations/Sandy Loading.gif";
const ValidateMobileModal = ({ isOpen, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const firstOtpsRef = useRef(null);
  const [step, setStep] = useState("login");
  const [errors, setErrors] = useState({ mobileno: "", otp: "" });
  const { login } = useAuth();
  const [timer, setTimer] = useState(30);
  const navigate = useNavigate();
  const [canResend, setCanResend] = useState(false);
  const [formData, setFormData] = useState({
    mobileno: "",
  });

  useEffect(() => {
    if (!isOpen) resetForm();
  }, [isOpen]);
  useEffect(() => {
    if (otp.length === 4 && step === "otp") {
      handleVerifyOTP();
    }
  }, [otp, step]);
  useEffect(() => {
    if (step === "otp" && firstOtpsRef.current) {
      firstOtpsRef.current.focus();
    }
  }, [step]);

  useEffect(() => {
    if (step !== "otp") return;

    if (timer <= 0) {
      setCanResend(true);
      return;
    }

    setCanResend(false);

    const countdown = setInterval(() => {
      setTimer((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(countdown);
  }, [timer, step]);

  const resetForm = () => {
    setFormData({ mobileno: "" });
    setOtp("");
    setErrors({});
    setOtpSent(false);
    setLoading(false);
    setTimer(30);
    setCanResend(false);
    setStep("login");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value.replace(/\D/g, ""),
    }));

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleBookNow = async () => {
    const { mobileno } = formData;
    let validationErrors = {};

    if (!mobileno.trim()) {
      validationErrors.mobileno = "Mobile number is required";
    } else if (mobileno.length !== 10) {
      validationErrors.mobileno = "Enter a valid 10-digit number";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    try {
      const body = new FormData();
      body.append("mobileno", mobileno);

      await axiosConfig.post("/accounts/validate_mobile/", body);

      setOtpSent(true);
      setStep("otp");
      setTimer(30);
      setCanResend(false);
    } catch (error) {
      setErrors({
        mobileno:
          error?.response?.data?.error || "Failed to send OTP. Try again!",
      });
    }
    setLoading(false);
  };

  const handleVerifyOTP = async () => {
      if (loading) return;
    const { mobileno } = formData;
    let validationErrors = {};

    if (!otp) {
      validationErrors.otp = "OTP is required";
    } else if (otp.length !== 4) {
      validationErrors.otp = "Enter 4-digit OTP";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    try {
      const body = new FormData();
      body.append("mobileno", mobileno);
      body.append("otp", otp);

      const res = await axiosConfig.post("/accounts/verify_otp/", body);

      if (res?.data?.token) {
        login(res.data.token, res.data.user_id);
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("mobileno", mobileno);
        onClose();
        navigate("/patient-dashboard/profile");
        resetForm();
      }
    } catch (error) {
      setErrors({
        otp: error?.response?.data?.error || "Incorrect OTP! Please try again",
      });
    }
    setLoading(false);
   
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="border-btm-1">
          <h3 className="title-services">Login</h3>
          <IoIosCloseCircleOutline
            size={24}
            color="#fff"
            style={{ cursor: "pointer" }}
            onClick={!loading ? onClose : undefined}
          />
        </div>

        {step === "login" && (
          <form className="modal-form">
            <label>Mobile Number</label>
            <input
              name="mobileno"
              type="tel"
              placeholder="+91 XXXXXXXXXX"
              maxLength={10}
              value={formData.mobileno}
              onChange={handleChange}
            />
            {errors.mobileno && <p className="error-text">{errors.mobileno}</p>}

            <button
              type="button"
              className="book-button mt-3 mb-3"
              onClick={handleBookNow}
              disabled={loading}
            >
              Login Now
            </button>
          </form>
        )}

        {step === "otp" && (
          <div className="otp-container">
            {loading && (
              <div className="otp-loader-overlay">
                <img src={sandyLoading} alt="Loading..." />
                <p>Verifying OTP...</p>
              </div>
            )}
            <div className="arrow-data">
              <HiArrowLongLeft
                className="F-icon"
                onClick={
                  !loading
                    ? () => {
                        setStep("login");
                        setOtp("");
                        setErrors((prev) => ({ ...prev, otp: "" }));
                      }
                    : undefined
                }
              />
              <h3 className="otp-title">Verify Contact</h3>
            </div>

            <p className="otp-msg">
              OTP sent to ****{formData.mobileno.slice(-4)}
            </p>

            <div className="otp-input-group">
              {[0, 1, 2, 3].map((i) => (
                <input
                  key={i}
                  id={`otp-${i}`}
                  className="otp-box"
                  type="tel"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  ref={i === 0 ? firstOtpsRef : null}
                  maxLength={1}
                  value={otp[i] || ""}
                  onChange={(e) => {
                    const val = e.target.value.replace(/\D/g, "");
                    const arr = otp.split("");

                    arr[i] = val;
                    setOtp(arr.join(""));

                    if (val && i < 3) {
                      document.getElementById(`otp-${i + 1}`).focus();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Backspace") {
                      const arr = otp.split("");
                      if (!otp[i] && i > 0) {
                        document.getElementById(`otp-${i - 1}`).focus();
                      }
                      arr[i] = "";
                      setOtp(arr.join(""));
                    }
                  }}
                />
              ))}
            </div>

            {errors.otp && <p className="error-text">{errors.otp}</p>}

            {canResend ? (
              <b className="resend-link" onClick={handleBookNow}>
                Resend OTP
              </b>
            ) : (
              <p className="login-msg">Resend in {timer}s</p>
            )}

            <p className="auto-verify-text">
              {loading
                ? "Verifying OTP..."
                : "OTP will be verified automatically"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ValidateMobileModal;
